import moment from 'moment/moment';
import ERC20 from '../abi/ERC20.json';
import { ethers } from 'ethers';
import { getAddress } from './get-address';
import TokenExchange from '../abi/TokenExchange.json';

const timestampToDays = (timestamp) => {
  timestamp = Number(timestamp);
  var d = Math.floor(timestamp / (3600 * 24));
  var dDisplay = d > 0 ? d + (d == 1 ? ' Day ' : ' Days ') : '';
  return dDisplay;
};

export const getGraveYard = async (_address) => {
  let success = false;
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const { chainId } = await provider.getNetwork();
    const addresses = getAddress(chainId);

    if (addresses) {
      const signer = provider.getSigner();
      const tokenExchange = new ethers.Contract(
        addresses.token_exchange_address,
        TokenExchange.abi,
        signer
      );
 
      const baseTokenDecimals = 18;

      const _graveYard = await tokenExchange.graveYards(_address);

    
      const exchangeRate =
        parseFloat(_graveYard.exchangeRate.toString()) /
        10 ** baseTokenDecimals;

      const graveYardMaxHope =
        ( parseFloat(_graveYard.graveYardMaxHope.toString()) - parseFloat(_graveYard.distributedAmount.toString()) ) / 10 ** baseTokenDecimals;


       
      if (
        _graveYard.variantAddress !=
          '0x0000000000000000000000000000000000000000' &&
        parseFloat(exchangeRate) > 0
      ) {
        return {
          success: true,
          exchangeRate,
          graveYardMaxHope: parseInt(Math.round(parseFloat(graveYardMaxHope))).toLocaleString(),
          vestingSchedule: _graveYard.vestingSchedule.toString(),
          address: _graveYard.variantAddress,
        };
      } else {
        return {
          success: false,
          message: 'Grave yard not found!',
        };
      }
    } else {
      return {
        success,
        message: 'Wrong network!',
      };
    }
  } catch (e) {
    return {
      success,
      message: e.message,
    };
  }
};
